import type { ItineraryGuest } from 'voyager';
import { GuestItinerary } from '@utils/getItineraryView';

const toHoursMinutes = (time: string): string => {
  const match = time.match(/^(\d{1,2}:\d{2})/);
  return match ? match[1] : time;
};

export const toItineraryGuests = (guestItineraries: GuestItinerary[]): ItineraryGuest[] =>
  guestItineraries
    .filter((guest) => guest.hasItems)
    .map((guest) => ({
      id: String(guest.guestNumber),
      name: guest.guestName,
      days: Object.entries(guest.items).map(([date, activities]) => ({
        date,
        activities: activities.map((activity, index) => ({
          id: `${guest.guestNumber}-${date}-${index}`,
          time: toHoursMinutes(activity.time),
          title: activity.name,
          location: activity.parent,
        })),
      })),
    }));
